import { escapeHtml } from "./escape-html"

interface ForwardRecipient {
	email: string
	name?: string
}

interface ForwardRecipients {
	to: readonly ForwardRecipient[]
	cc: readonly ForwardRecipient[]
	bcc: readonly ForwardRecipient[]
}

export function forwardRecipientEmails({ to, cc, bcc }: ForwardRecipients) {
	const seen = new Set<string>()
	return [...to, ...cc, ...bcc]
		.map((recipient) => recipient.email.trim())
		.filter((email) => {
			const key = email.toLocaleLowerCase()
			if (!email || seen.has(key)) return false
			seen.add(key)
			return true
		})
}

// The internal comment that records a forward, so the team sees who got the thread.
export function forwardCommentHtml(
	recipients: ForwardRecipients,
	noteHtml: string,
) {
	const list = forwardRecipientEmails(recipients).map(escapeHtml).join(", ")
	const note = noteHtml.trim()
	return `<p><strong>Forwarded to</strong> ${list}</p>${note}`
}
